import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: flex-start;
  padding: 25px;
  background-color: #f1f0f3;
  width: 100%;
  max-width: 395px;
  margin: 0 auto;
  &.monthly {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  @media (max-width: 480px) {
    padding: 20px;
  }

  img {
    width: 37px;
    margin-right: 20px;

    @media (max-width: 480px) {
      width: 25px;
      margin-right: 10px;
    }
  }

  h3 {
    color: #2d1441;
    font-weight: bold;
    margin-bottom: 5px;
    line-height: 20px;

    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  p {
    line-height: 20px;
  }
`;

export default ErrorContainer;
